import { useClickStreamContext } from 'features/shared/ClickStream';
import { useState } from 'react';

interface EventData {
  eventType: string;
  eventInfo: string;
}
const useModal = (eventOpenModal: EventData, eventCopyClick: EventData) => {
  const { logPageEvent } = useClickStreamContext();

  const [showModal, setShowModal] = useState(false);

  const handleImproveClick = () => {
    setShowModal(true);
    logPageEvent(eventOpenModal);
  };

  const handleCopyClick = () => {
    logPageEvent?.(eventCopyClick);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return {
    showModal,
    handleImproveClick,
    handleCopyClick,
    handleCloseModal,
  };
};

export default useModal;
